import { apiGet, apiSend } from './client';
import type { EncounterSummary, ReportDetailResponse, ReportParticipantSummary, ReportSummary } from './types';

function reportListSuffix(params?: { limit?: number; serverSlug?: string; serverId?: number; guildId?: string }) {
  const search = new URLSearchParams();
  if (params?.limit) search.set('limit', String(params.limit));
  if (params?.serverSlug) search.set('serverSlug', params.serverSlug);
  if (params?.serverId) search.set('serverId', String(params.serverId));
  if (params?.guildId) search.set('guildId', params.guildId);
  const suffix = search.toString();
  return suffix ? `?${suffix}` : '';
}

export async function fetchRecentReports(params?: { limit?: number; serverSlug?: string; serverId?: number; guildId?: string }) {
  const data = await apiGet<{ reports: ReportSummary[] }>(`/reports/recent${reportListSuffix(params)}`);
  return data.reports;
}

export async function fetchMyReports(params?: { limit?: number; serverSlug?: string; serverId?: number; guildId?: string }) {
  const data = await apiGet<{ reports: ReportSummary[] }>(`/me/reports${reportListSuffix(params)}`);
  return data.reports;
}

export async function fetchGuildReports(guildId: string, params?: { limit?: number; serverSlug?: string; serverId?: number }) {
  const data = await apiGet<{ reports: ReportSummary[] }>(`/guilds/${encodeURIComponent(guildId)}/reports${reportListSuffix(params)}`);
  return data.reports;
}

export async function fetchReport(id: string) {
  return apiGet<ReportDetailResponse>(`/reports/${encodeURIComponent(id)}`);
}

export async function fetchReportEncounters(id: string) {
  const data = await apiGet<{ encounters: EncounterSummary[] }>(`/reports/${encodeURIComponent(id)}/encounters`);
  return data.encounters;
}

export async function fetchReportParticipants(id: string) {
  const data = await apiGet<{ participants: ReportParticipantSummary[] }>(`/reports/${encodeURIComponent(id)}/participants`);
  return data.participants;
}

export async function updateReportName(id: string, name: string | null) {
  const data = await apiSend<{ report: ReportSummary }>(`/reports/${encodeURIComponent(id)}`, 'PATCH', { name });
  return data.report;
}

export async function reportLogReport(id: string, reason?: string) {
  const data = await apiSend<{ report: import('./types').ReportContentReport }>(`/reports/${encodeURIComponent(id)}/report`, 'POST', { reason });
  return data.report;
}

export async function deleteReport(id: string, reason?: string) {
  const data = await apiSend<{ report: ReportSummary }>(`/reports/${encodeURIComponent(id)}`, 'DELETE', { reason });
  return data.report;
}
